import { makeStyles } from "../../../theme/MUIImports";

export const useStyles = makeStyles((theme) => ({
    alertBox    : {
        color : 'red !important',
        '& .MuiAlert-message'   :   {
            wordBreak   :   'break-all',
        }
    }
}));